/* Move the existing checkout, never clone it: IDs, terms and native handlers remain intact. */
(() => {
  'use strict';
  if (window.bpCartLayoutReady) return;
  window.bpCartLayoutReady = true;
  function install() {
    const drawer = document.getElementById('site-cart-sidebar');
    if (!drawer || drawer.dataset.bpCheckoutFirst) return;
    let scheduled = false;
    function arrange() {
      scheduled = false;
      const form = drawer.querySelector('#AjaxCartForm');
      const footer = drawer.querySelector('.sidebar__footer');
      const shelf = drawer.querySelector('[data-bp-cart-collection]');
      if (!form || !footer || !shelf || !form.parentElement) return;
      if (form.nextElementSibling !== footer) form.after(footer);
      if (footer.nextElementSibling !== shelf) footer.after(shelf);
      footer.classList.add('bp-cart-checkout-first');
      drawer.dataset.bpCheckoutFirst = 'true';
    }
    function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(arrange); } }
    arrange();
    new MutationObserver(schedule).observe(drawer, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install); else install();
  document.addEventListener('shopify:section:load', install);
})();
